module.exports = __webpack_public_path__ + "img/case-session-persistence.a5cb8901.png";